import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={50}
    height={50}
    fill="none"
    {...props}
  >
    <circle cx={25} cy={25} r={15} fill="#666" />
  </svg>
)
export default SvgComponent
